import { type Href } from 'expo-router';
import { type ReactNode } from 'react';
import { Text as RNText, View } from 'react-native';

import { Button } from './Button';
import { cn } from './cn';

export interface SectionHeaderProps {
  /** Uppercase mono label, e.g. "Templates". */
  label: string;
  /** Optional count shown as "· N". */
  count?: number | string;
  /** Optional trailing action, rendered as a "create" chip button (e.g. "New" or "View all"). */
  actionLabel?: string;
  /** Navigation target for the action button — renders a real `<a href>` on web. */
  actionHref?: Href;
  onAction?: () => void;
  /** Leading glyph for the action button (e.g. "+"). */
  actionIcon?: string;
  /** Trailing glyph for the action button (e.g. a "›" chevron). */
  actionIconRight?: string;
  right?: ReactNode;
  className?: string;
}

/** "TEMPLATES · 4" row with an optional trailing action. */
export function SectionHeader({
  label,
  count,
  actionLabel,
  actionHref,
  onAction,
  actionIcon,
  actionIconRight,
  right,
  className,
}: SectionHeaderProps) {
  return (
    <View className={cn('flex-row items-center justify-between', className)}>
      <RNText className="font-accent text-xs uppercase tracking-[0.12em] text-muted">
        {label}
        {count !== undefined ? `  ·  ${count}` : ''}
      </RNText>
      {right ??
        (actionLabel ? (
          <Button
            variant="create"
            size="sm"
            label={actionLabel}
            icon={actionIcon}
            iconRight={actionIconRight}
            href={actionHref}
            onPress={onAction}
            hitSlop={8}
          />
        ) : null)}
    </View>
  );
}
